import { Controller } from "stimulus";

export default class extends Controller {

  static targets = [
    "flaggable",
    "type",
  ];

  initialize() {
    this.showFlaggable = this.showFlaggable.bind(this);
  }

  connect() {
    this.showFlaggable();
    this.typeTarget.addEventListener('change', this.showFlaggable);
  }

  disconnect() {
    this.typeTarget.removeEventListener('change', this.showFlaggable);
  }

  showFlaggable() {
    if (this.typeTarget.value === 'Induction::AdditionalQuestion::Boolean' || this.typeTarget.value === 'Abstract::AdditionalQuestion::Boolean') {
      let el = this.flaggableTarget;
      el.classList.remove('hide');
      el.style.display = "block";
    } else {
      let el = this.flaggableTarget;
      el.classList.add('hide');
    }
  }

}